import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { PhysicalExaminationForm } from '../../models';

/**
 * Physical Examination Form
 */
@Component({
    selector: 'app-physical-examination-form',
    templateUrl: './physical-examination-form.component.html',
    styleUrls: ['./physical-examination-form.component.scss'],
    standalone: false,
})
export class PhysicalExaminationFormComponent {
    /**
     * Form group
     */
    @Input() formGroup: FormGroup<PhysicalExaminationForm>;

    /**
     * Is bed side mode
     */
    @Input() isBedSideMode: boolean;

    /**
     * Is form active / visible
     */
    @Input() isActive: boolean;

    /**
     * Max textarea rows count size
     */
    @Input() textareaMaxRows = 40;

    /**
     * Keyboard enter clicked
     */
    @Output() keyboardEnterClicked: EventEmitter<void> = new EventEmitter();
}
